export default "__VITE_ASSET__aa1141ec__"